export const SET_ORDER_TRACKING_GUID = "SET_ORDER_TRACKING_GUID";
export const GET_ORDER_TRACKING_REQUEST = "GET_ORDER_TRACKING_REQUEST";
export const GET_ORDER_TRACKING_SUCCESS = "GET_ORDER_TRACKING_SUCCESS";
export const GET_ORDER_TRACKING_ERROR = "GET_ORDER_TRACKING_ERROR";
export const TRACKING_ADD_UPDATE_CAPTAIN = "TRACKING_ADD_UPDATE_CAPTAIN";
export const TRACKING_UPDATE_CAPTAIN_STATUS = "TRACKING_UPDATE_CAPTAIN_STATUS";
export const SET_ORDER_TRACKING_SECURED_TOKEN = "SET_ORDER_TRACKING_SECURED_TOKEN";
export const GET_ORDER_TRACKING_SECURED_REQUEST = "GET_ORDER_TRACKING_SECURED_REQUEST";
